import axios from 'axios';
import Auth0 from '../../../../../../store/actions/auth/Auth';
import { toast } from 'react-toastify';

export const DELETE_UPLOAD = 'DELETE_UPLOAD';
export const DELETE_UPLOAD_PENDING = 'DELETE_UPLOAD_PENDING';
export const DELETE_UPLOAD_FULFILLED = 'DELETE_UPLOAD_FULFILLED';
export const DELETE_UPLOAD_REJECTED = 'DELETE_UPLOAD_REJECTED';

export const actionCreators = {
  deleteSingleUpload: (deliveryId, navigate) => async (dispatch) => {
    dispatch({
      type: DELETE_UPLOAD_PENDING,
    });
    
    try {
      await axios.delete(`/api/admin/deliveries/fromCustomer/${deliveryId}`, {
        headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
      });
      
      dispatch({
        type: DELETE_UPLOAD_FULFILLED
      });
      
      toast.success('Leveransen har raderats');
      
      // Use navigate function passed as parameter
      if (navigate) {
        navigate(-1); // Go back one step in history
      }
    } catch (err) {
      dispatch({
        type: DELETE_UPLOAD_REJECTED,
        error: err
      });
      
      toast.error('Leveransen kunde inte raderas. Kontakta supporten om felet kvarstår.');
    }
  }
};
